import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./functionalAdminSlice";
import MessageSnackbar from "../../components/ui/MessageSnackbar";

export default function MessageForFunctionalAdmin() {
    const dispatch = useDispatch();
    const functionAdmin = useSelector((store) => store.functionAdmin);
    const { message, severity, messageOpen } = functionAdmin;

    const handleCloseSnackbar = () => {
        dispatch(setState("messageOpen", false));
    };

    return (
        <MessageSnackbar
            message={message}
            severity={severity}
            open={messageOpen}
            onClose={handleCloseSnackbar}
        />
    );
}